import { SimplifiedUser } from "../../Models/User";
import api from "../axios";

export const authService = {
  refreshToken: async (): Promise<SimplifiedUser> => {
    const response = await api.post<SimplifiedUser>('/auth/refresh-token', undefined, {
      skipAuthInterceptor: true,
    });
    return response.data;
  }
};
